import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactEcharts from 'echarts-for-react'
import { 
  getCorrelationChart, 
  getHoldingsOverlapChart,
  getHoldingsOverlapCountChart, 
  getHoldingsOverlapRelativeLeftChart, 
  getHoldingsOverlapRelativeRightChart 
} from '../charts.js'
import i18n from '../../../i18n'
import './KeyMetrics.css'
import CompText from '../Compliance/CompText'
import MetricsTable from './MeticsTable/MetricsTable.js'
import TopHoldings from './TopHoldings/TopHoldings.js'
import ProgressBar from '../Components/ProgressBar.js'
import { SomethingWentWrong } from '../Components/ErrorHandle.js'


class KeyMetrics extends Component {

  getGrossFees(data) {
    return data.map(fund => {
      if (fund.expenseRatioGross) {
        return (fund.expenseRatioGross * 100).toFixed(2)
      } else {
        return '-'
      }
    })
  }

  renderCorrelationHeatmap() {
    const { data, loadingConstituents, loadingPerformanceData } = this.props

    if (loadingPerformanceData || loadingConstituents || !data[0].stdPerformanceMonthly) {
      return null
    }    

    const asOfDate = new Date(data[0].stdPerformanceMonthly[0].asOfDate).toLocaleDateString()
    for (let i = 0; i < data.length; i++) {
      if (!data[i].correlations || !data[i].correlations?.keys) {
        return null
      }
    }
    if (data.length > 1) {
      return (
        <React.Fragment>
          <div className='chartHeader'>
            <span style={{ textTransform: 'uppercase' }}>{i18n.t('Performance Correlation')}</span> {i18n.t('as of')} {asOfDate}
          </div>
          <div className='chartContainer'>
            <ReactEcharts option={getCorrelationChart(data)} theme='default' style={{ height: 400 }} />
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  renderOverlapsHeatmap(asOfDate) {
    const { data, loadingConstituents, loadingPerformanceData } = this.props

    if (loadingPerformanceData || loadingConstituents) {
      return null
    }  

    const funds = data.filter(fund => fund.overlaps)

    if (funds.length > 1) {
      return (
        <React.Fragment>
          <div className='chartHeader'>
            <span style={{ textTransform: 'uppercase' }}>{i18n.t('Holdings Overlap')}</span> {i18n.t('as of')} {asOfDate}
          </div>
          <div className='chartContainer'>
            <ReactEcharts option={getHoldingsOverlapChart(funds)} theme='default' style={{ height: 400 }} />
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  renderOverlapsCountHeatmap(asOfDate) {
    const { data, loadingConstituents, loadingPerformanceData } = this.props

    if (loadingPerformanceData || loadingConstituents) {
      return null
    }

    const funds = data.filter(fund => fund.overlaps)
    

    if (funds.length > 1) {
      return (
        <React.Fragment>
          <div className='chartHeader'>
            <span style={{ textTransform: 'uppercase' }}>{i18n.t('Holdings Overlap Count')}</span> {i18n.t('as of')} {asOfDate}
          </div>
          <div className='chartContainer'>
            <ReactEcharts option={getHoldingsOverlapCountChart(funds)} theme='default' style={{ height: 400 }} />
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  renderOverlapsRelativeLeftHeatmap(asOfDate) {
    const { data, loadingConstituents, loadingPerformanceData } = this.props

    if (loadingPerformanceData || loadingConstituents) {
      return null
    } 

    const funds = data.filter(fund => fund.overlaps)

    
    const tickers = data.map(fund => fund.ticker)
    const tickersStr = tickers.join(',')

    if (funds.length > 1) {
      return (
        <React.Fragment>
          <div className='chartHeader'>
            <span>
              {i18n.t('SUM OF ')} {tickersStr} {i18n.t('WEIGHT FOR COMMON SECURITIES')}
            </span>{' '}
            {i18n.t(' as of')} {asOfDate}
          </div>
          <div className='chartContainer'>
            <ReactEcharts option={getHoldingsOverlapRelativeLeftChart(funds)} theme='default' style={{ height: 400 }} />
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  renderOverlapsRelativeRightHeatmap(asOfDate) {
    const { data, loadingConstituents, loadingPerformanceData } = this.props
    const funds = data.filter(fund => fund.overlaps)

    if (loadingPerformanceData || loadingConstituents) {
      return null
    }
   

    if (funds.length > 1) {
      
      return (
        <React.Fragment>
          <div className='chartHeader'>
            <span style={{ textTransform: 'uppercase' }}>
              {i18n.t('Holdings Overlap')} {'<--'}
            </span>{' '}
            {i18n.t('as of')} {asOfDate}
          </div>
          <div className='chartContainer'>
            <ReactEcharts option={getHoldingsOverlapRelativeRightChart(funds)} theme='default' style={{ height: 400 }} />
          </div>
        </React.Fragment>
      )
    } else {
      return null
    }
  }

  render() {
    const { data, loadingPerformanceData, loadingConstituents, errorPerformanceData, errorConstituents } = this.props
    const hasLevels = data.filter(x => x.levels !== null);
    const hasPerfData = hasLevels.length > 0 
    
    const topHoldings = data.filter(x => x.topHoldings !== null);
    const hasTopHoldings = topHoldings.length > 0     

    const EqIncFund = data.filter(x => x.assetClass !== 'Fixed Income')
    const corrStyle = { paddingRight: '0px', marginBottom: '65px' }
    if (EqIncFund.length <= 1) {
      corrStyle.paddingLeft = '0px'
    }
    const partDataLoading = hasPerfData && loadingPerformanceData

    //has no data loaded but still grabbing data
    if(!hasPerfData && loadingPerformanceData) {
      return (
        <div>
          <ProgressBar title={'KEY METRICS'} message={i18n.t('loading_metrics')} />
          <CompText pane='KeyMetrics' />
        </div>
      )
    }

    if (errorPerformanceData && errorConstituents) {
      return (
        <div>
          <SomethingWentWrong />
          <CompText pane='KeyMetrics' />
        </div>
      )
    }

    const RenderTopHoldingsAndOverLapsMain = () => {
      if(!errorConstituents) {
        return(
          <div>
            <HeatMaps />
            <TopHoldings />
          </div>
        )
      }
    }
  

    const HeatMaps = () => {

      const { errorPerformanceData, data } = this.props

      const today = new Date();
      const quarter = Math.floor((today.getMonth() / 3));
      const startFullQuarter = new Date(today.getFullYear(), quarter * 3 - 3, 1);
      const endFullQuarter = new Date(startFullQuarter.getFullYear(), startFullQuarter.getMonth() + 3, 0);
      let asOfDate = endFullQuarter.toLocaleDateString()
      if (!loadingPerformanceData && data.length > 1 && !errorPerformanceData) {
        asOfDate = new Date(data[0].stdPerformanceMonthly[0].asOfDate).toLocaleDateString()
      } 
    
      return(
        <div>
        <div className='row'>
      <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
        {this.renderCorrelationHeatmap(asOfDate)}
      </div>
      {EqIncFund.length > 1 && (
        <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
          {this.renderOverlapsHeatmap(asOfDate)}
        </div>
      )}
      {EqIncFund.length > 1 && (
        <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
          {this.renderOverlapsCountHeatmap(asOfDate)}
        </div>
      )}

      {EqIncFund.length > 1 && (
        <div className='col-md-6 col-sm-12' style={{ paddingLeft: '0px', marginBottom: '65px' }}>
          {this.renderOverlapsRelativeLeftHeatmap(asOfDate)}
        </div>
      )}
        </div>
         </div>
      )
    }

    return (
      <div className='key-metrics'>
        <MetricsTable partDataLoading={partDataLoading}/>
        {loadingConstituents && !hasTopHoldings ? (
          <ProgressBar message={i18n.t('loading_holdings')} />
        ) : (
          <RenderTopHoldingsAndOverLapsMain />
        )}
        <CompText pane='KeyMetrics' />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    loadingPerformanceData: state.fundData.loadingPerformanceData,
    errorPerformanceData: state.fundData.errorPerformanceData,
    loadingConstituents: state.fundData.loadingConstituents,
    errorConstituents: state.fundData.errorConstituents,
    hasBlendedData: state.fundData.hasBlendedData
  }
}

export default connect(mapStateToProps, {})(KeyMetrics)
